import React from 'react'
import { useTranslation } from 'react-i18next'
import { BeWizrEmbedItem } from '~/models'
import { memo } from '~/ui/component'
import { TextBlock } from '~/ui/components'
import BeWizrTile from '../../bewizr/BeWizrTile'
import { register } from './registry'

export interface Props {
  item: BeWizrEmbedItem
}

const BeWizrEmbedLibraryItem = memo('BeWizrEmbedLibraryItem', (props: Props) => {

  const {item} = props
  const embed = item.embedJson

  const [t] = useTranslation('bewizr-misc-items')

  const image = React.useMemo(() => {
    if (item.links.image != null) {
      return item.links.image
    } else if (embed.type === 'photo') {
      return embed.url
    } else if (embed.thumbnailUrl != null) {
      return embed.thumbnailUrl
    } else {
      return null
    }
  }, [item, embed])

  //------
  // Rendering

  function render() {
    return (
      <BeWizrTile
        label={t('bewizr-library:item-types.embeditem')}
        title={item.title}
        href={`/bewizr-misc-items/embed/-/${item.id}`}
        icon='video'
        image={image}
        buttonCaption={t('embed.view')}
        horizontal
      >
        {item.shortDescription && (
          <TextBlock dim small>
            {item.shortDescription}
          </TextBlock>
        )}
      </BeWizrTile>
    )
  }

  return render()

})

register('embeditem', BeWizrEmbedLibraryItem)